<script setup lang="ts">
import { type Themes, getTheme, themes, useThemeStore } from '@/stores/themes';
import { useRoute } from 'vue-router';
import { computed, onMounted } from 'vue';

const route = useRoute();
// eslint-disable-next-line unused-imports/no-unused-vars
const Component = computed(() => getTheme(themeStore.theme).component);

const themeStore = useThemeStore();
const switchTheme = (theme: Themes['name']) => {
  useThemeStore().setTheme(theme);
};

onMounted(() => {
  const theme = route.query.theme as Themes['name'];
  if (route.query.theme !== undefined && themes.map((theme) => theme.name).includes(theme)) {
    switchTheme(theme);
  }
});
</script>

<template>
  <div>
    <Component />
  </div>
</template>
